import http from "../../../util/http"
const prefix = "/share-foreign"
export default{
  /**
   *获取公司列表
   *
   * @param {{visitCountryCode: String,taskType: String,leaderName: String}} data
   * @returns
   */
  companyList(data){
    return http.post(prefix+"/offline/renewalPassport/renewalPassportEntPage",data)
  },
  corporationList(data){
    return http.post(prefix+"/offline/renewalPassport/renewalPassportPage",data)
  },
  /**
   *获取详情
   *
   * @param {{renewalId: String}} data
   * @returns
   */
  detail(data){
    return http.post(prefix+"/offline/renewalPassport/getDetails",data)
  },
  /**
   *护照换发 生成日志
   *
   * @param {{id: String}} data
   * @returns
   */
   addGenerateLog(data){
    return http.post(prefix+"/offline/renewalPassport/addGenerateLog",data)
  },
  /**
   *获取注销详情
   *
   * @param {{destroyId: String}} data
   * @returns
   */
  destoryDetail(data){
    return http.post(prefix+"/offline/destroyPassport/details",data)
  },
  /**
   *删除
   *
   * @param {{renewalId: String}} data
   */
  remove(data){
    return http.post(prefix+"/offline/renewalPassport/delete",data)
  },
  /**
   *提交
   *
   * @param {{renewalId: String}} data
   * @returns
   */
  submit(data){
    return http.post(prefix+"/offline/renewalPassport/submit",data)
  },
  /**
   *退回
   *
   * @param {{renewalId: String}} data
   * @returns
   */
  fallback(data){
    return http.post(prefix+'/offline/renewalPassport/fallback',data)
  },
  /**
   *完结
   *
  * @param {{renewalId: String}} data
   * @returns
   */
  finish(data){
    return http.post(prefix+"/offline/renewalPassport/complete",data)
  },
  /**
   *提交审批
   *
  * @param {{renewalId: String}} data
   * @returns
   */
  approval(data){
    return http.post(prefix+"/offline/renewalPassport/submitApproval",data)
  },
  /**
   * 获取补录列表
   */
  renewList(data){
    return http.post(prefix+"/offline/renewalPassport/getCert",data)
  },
  /**
   *补录护照
   *
   * @param {{list: Object[]}} data
   * @returns
   */
  renewPassport(data){
    return http.post(prefix+"/offline/renewalPassport/saveCertificationInfo",data)
  },
  /**
   *新增和编辑换发函
   *
   * @param {*} data
   * @returns
   */
  add(data){
    return http.post(prefix+"/offline/renewalPassport/renewalPassportAddOrEdit",data)
  },
  addPerson(data){
    return http.post(prefix+"/offline/renewalPassportUser/addOrEdit",data)
  },
  delPerson(data){
    return http.post(prefix+"/offline/renewalPassportUser/del",data)
  },
  /**
   *同意函
   *
   * @param {{renewalId: String,agreeFile: String}} data
   * @returns
   */
  uploadAgree(data){
    return http.post(prefix+"/offline/renewalPassport/uploadAgreeFile",data)
  },
  /**
   *提交任务
   *
   * @param {{renewalId: String, agree: String, opinion: String}} data
   * @returns
   */
  submitTask(data){
    return http.post(prefix+"/offline/renewalPassport/submitTask",data)
  },
   /**
   * 护照注销 修改开函时间
   * 
   */
  editOpenTime(data){
    return http.post(prefix+"/offline/destroyPassport/updateOpenTime",data)
  },

  /**
   * 换发/补发管理 修改开函时间
   * 
   */
  editOpenExchangeTime(data){
    return http.post(prefix+"/offline/renewalPassport/updateOpenTime",data)
  },

  //保存换发函件信息
  saveLetter(data){
    return http.post(prefix+"/offline/renewalPassport/saveLetter",data)
  },
  
}